import {Platform} from 'react-native';

import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';
import {isWeb} from '@/utils/platform';

export const styles = createThemedStyles(
  (theme, responsive, safeAreaInsets) => ({
    container: {
      pointerEvents: 'box-none',
      position: 'absolute',
      top: safeAreaInsets.top + (responsive.isMobile ? spacing.xs : spacing.l),
      ...Platform.select({
        web: {
          alignSelf: 'center',
          marginHorizontal: spacing.l,
        },
        native: {
          left: spacing.l,
          right: spacing.l,
        },
      }),
      zIndex: isWeb ? 10000 : undefined,
      justifyContent: 'center',
      alignItems: 'center',
      gap: spacing.xs,
    },
  }),
);
